import { useAuth0 } from "@auth0/auth0-react";
import { FC, useEffect, useState } from "react";

export const TokenSetup: FC = ({ children }) => {
  const { isAuthenticated, getAccessTokenSilently, isLoading } = useAuth0();
  const [tokenPresent, setTokenPresent] = useState(false);

  const isCypress = process.env.REACT_APP_IS_CYPRESS;

  const isPermissionGranted = isCypress
    ? !!localStorage.getItem("token")
    : tokenPresent;

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: "read",
      })
        .then((token) => {
          localStorage.setItem("token", token);
          setTokenPresent(true);
        })
        .catch((e) => console.warn(e));
    }
  }, [isAuthenticated, getAccessTokenSilently, isLoading]);

  return isPermissionGranted ? <>{children}</> : <>Getting Token</>;
};

export default TokenSetup;
